const { h, render, Component } = require('preact');
const InputTime = require('./input_time')

class DateTime extends Component {
  constructor(props) {
    super(props);
    this.changeDateTimeState = this.changeDateTimeState.bind(this)
    this.getDateInputHtmlElement = this.getDateInputHtmlElement.bind(this)
  }

  changeDateTimeState() {
    this.props.updateState(this.props.attrs.type, this.props.attrs.counter, this.populateInput(), this.validateInput())
  }

  getDateInputHtmlElement() {
    var elementId = "v2-date" + this.props.attrs.counter
    return document.getElementById(elementId)
  }

  readInput() {
    var date = {}
    var dateElement = this.getDateInputHtmlElement()
    if (dateElement) {
      date = dateElement.value
    }
    return date
  }

  validateInput() {
    if (this.props.attrs.required  == "true") {
      return this.getDateInputHtmlElement().value.trim().length > 0
    }
    return true
  }

  populateInput() {
    var data = {}
    var inputData = this.readInput()
    data.description = `\n\n ${this.props.attrs.label} : ${inputData}`;
    return data
  }

  componentDidMount() {
    var dateElement = this.getDateInputHtmlElement()
    if (dateElement) {
      dateElement.addEventListener("change", this.changeDateTimeState)
    }
  }

  render() {
    let attrs = this.props.attrs

    return (
      <div>
        <label><strong>{attrs.label}
          {attrs.required == "true" ? (<span class="mandatory-field"> * </span>) : null}
        </strong></label>
          <input type="datetime-local" class="date-time-input" id={"v2-date" + attrs.counter} name="date" />
      </div>
    )
  }
}

module.exports = DateTime
